var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.48,8.73,10.19,5.94H8.58v3.9L6.91,5.94H5.44L3.67,10.06H4.75l.38-.92H7.18l.38.92h2V6.83L11,10.06h.87l1.42-3.23v3.23h1V5.94h-1.6Zm-6-.45.68-1.64.67,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,5.94,20.35,7.29,19.13,5.94h-4v4.12h3.9L20.33,8.7l1.21,1.36h1.27L21,8l1.84-2.07Zm-3,3.27H16.15V8.39h2.16V7.55H16.15V6.79h2.47L19.7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.26,0H.74A.75.75,0,0,0,0,.74V15.26A.74.74,0,0,0,.74,16H26.26a.74.74,0,0,0,.74-.74V.74A.74.74,0,0,0,26.26,0Zm-1.6,10.88H21.12L20.33,10l-.84.89h-6.9v-.71l-.3.71H10.57l-.29-.7v.7H7L6.58,10H5.73l-.38.91h-3L4.86,5.12H7.43l.33.68V5.12h3l.66,1.48.65-1.48h7.51l.76.88.82-.88h3.49L22.14,8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/AMEX.9e159b8fdda2408b325c66a48b6b0b74.svg";
export { ForwardRef as ReactComponent };